export function Academy() {
  return (
    <div className="page">
      <h1>Academy</h1>
      <p className="muted">Phase 1 placeholder. Phase 4 will add structured lessons and explainers.</p>
      <div className="list-grid">
        <article className="list-card">
          <h3>What is liquidation pressure?</h3>
          <p>
            A composite score combining 24h move magnitude, top-of-book spread, and
            order-book imbalance. Higher means more positions are closer to forced unwind.
          </p>
        </article>
        <article className="list-card">
          <h3>Reading the risk regime</h3>
          <p>
            Volatility regime is normalized to 0–100. Above 60 is generally a high-vol
            regime where stops widen and slippage rises.
          </p>
        </article>
        <article className="list-card">
          <h3>Why Bitxian is informational</h3>
          <p>
            Bitxian aggregates and explains. It does not custody funds and does not auto-trade.
            Read Blueprint §14 for the full security rules.
          </p>
        </article>
      </div>
    </div>
  );
}
